import { render, staticRenderFns } from "./RepositoryTokenUpdate.vue?vue&type=template&id=0045fab2&"
import script from "./RepositoryTokenUpdate.vue?vue&type=script&lang=js&"
export * from "./RepositoryTokenUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports